module.exports = __webpack_public_path__ + "img/content4.77c7a92b.png";